document.addEventListener('DOMContentLoaded', function() {

  // ── 1. DIAMOND BAR ──
  var diamond = null;
  try { diamond = JSON.parse(sessionStorage.getItem('diamore_diamond') || 'null'); } catch(e) {}

  var bar = document.getElementById('pdp-diamond-bar');
  var diamondVal = document.getElementById('pdp-diamond-val');
  if (diamond && bar && diamondVal) {
    var price = Math.ceil(diamond.price_with_markup || diamond.price || 0);
    diamondVal.textContent =
      (diamond.carats || diamond.carat || '') + 'ct \u00b7 ' +
      (diamond.color || '') + ' \u00b7 ' +
      (diamond.clarity || '') + ' \u00b7 ' +
      (diamond.shape || '') + ' \u00b7 ' +
      (diamond.cert || diamond.certLab || diamond.cert_lab || '') + ' \u00b7 ' +
      '$' + price.toLocaleString('en-US');
    bar.style.display = 'flex';
  }
  var changeBtn = document.getElementById('pdp-change-diamond');
  if (changeBtn) {
    changeBtn.addEventListener('click', function() {
      window.location.href = '/pages/ring-builder-diamond';
    });
  }

  // ── 2. METAL SWATCHES (color por JS + fallback click via __variants) ──
  document.querySelectorAll('.pdp-mswatch').forEach(function(sw) {
    var metal = (sw.dataset.metal || '').toLowerCase();
    sw.style.background = metal.indexOf('amarillo') !== -1 ? '#D4A820' : '#C8D4DC';
    sw.addEventListener('click', function() {
      if (!window.__variants) return;
      var variant = window.__variants.find(function(v) {
        return (v.title || '').toLowerCase().includes(metal) ||
               (v.option1 || '').toLowerCase().includes(metal);
      });
      if (!variant) return;
      var imgEl = document.getElementById('pdp-main-img');
      if (imgEl && variant.featured_image && variant.featured_image.src) {
        imgEl.src = variant.featured_image.src + '&width=900';
      }
      var priceEl2 = document.getElementById('pdp-price');
      if (priceEl2 && variant.price) {
        priceEl2.textContent = '$' + (variant.price / 100).toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
      }
      window._pdpSelectedVariantId = String(variant.id);
    });
  });

  // ── 3. METAL SELECTOR ──
  var mainImg = document.getElementById('pdp-main-img');
  var priceEl = document.getElementById('pdp-price');
  var metalValEl = document.getElementById('pdp-metal-val');
  var metalBtns = document.querySelectorAll('.pdp-mbtn');

  // Estado compartido: metal y stone type activos
  var _activeMetalTitle = '';
  var _activeStoneType = sessionStorage.getItem('diamore_stone_type') || 'lab';

  // Encuentra la variante que mejor coincide con metal + stone type.
  // Si el producto no tiene opción de origen, devuelve la primera variante del metal.
  function findSettingVariant(metalTitle, stoneType) {
    var variants = (window.DiamoreSettingPDP || {}).variants || [];

    // Determinar si el producto usa variantes de origen
    var hasOriginVariants = variants.some(function(v) {
      var o2 = (v.option2 || '').toLowerCase();
      var o3 = (v.option3 || '').toLowerCase();
      return o2.indexOf('lab') !== -1 || o2.indexOf('natural') !== -1 ||
             o3.indexOf('lab') !== -1 || o3.indexOf('natural') !== -1;
    });

    return variants.find(function(v) {
      if (metalTitle && v.option1 !== metalTitle) return false;
      if (!hasOriginVariants) return true; // sin variantes de origen → primera del metal

      var o2 = (v.option2 || '').toLowerCase();
      var o3 = (v.option3 || '').toLowerCase();
      if (stoneType === 'lab') {
        return o2.indexOf('lab') !== -1 || o3.indexOf('lab') !== -1;
      } else {
        return o2.indexOf('natural') !== -1 || o3.indexOf('natural') !== -1;
      }
    }) || null;
  }

  function applyVariant(variant, imgSrcOverride) {
    if (!variant) return;
    // Precio
    if (priceEl) {
      priceEl.textContent = '$' + (variant.price / 100).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }
    // Variant ID para el carrito / flujo RB
    window._pdpSelectedVariantId = String(variant.id);
    // Imagen
    var imgSrc = imgSrcOverride || variant.featured_image;
    if (mainImg && imgSrc) {
      mainImg.src = imgSrc;
      document.querySelectorAll('.pdp-thumb').forEach(function(t) {
        t.classList.remove('pdp-thumb--active');
      });
      var firstThumb = document.querySelector('.pdp-thumb');
      if (firstThumb) firstThumb.classList.add('pdp-thumb--active');
    }
  }

  metalBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      metalBtns.forEach(function(b) { b.classList.remove('pdp-mbtn--active'); });
      btn.classList.add('pdp-mbtn--active');
      _activeMetalTitle = btn.dataset.title || '';
      if (metalValEl) metalValEl.textContent = _activeMetalTitle;

      var variant = findSettingVariant(_activeMetalTitle, _activeStoneType);
      applyVariant(variant, btn.dataset.image || null);
    });
  });

  // Inicializar variante seleccionada
  var activeMetalBtn = document.querySelector('.pdp-mbtn--active');
  if (activeMetalBtn) {
    _activeMetalTitle = activeMetalBtn.dataset.title || '';
    var initVariant = findSettingVariant(_activeMetalTitle, _activeStoneType);
    if (initVariant) {
      window._pdpSelectedVariantId = String(initVariant.id);
      // Actualizar precio si difiere del Liquid (por stone type guardado)
      if (priceEl) {
        priceEl.textContent = '$' + (initVariant.price / 100).toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
      }
    } else {
      window._pdpSelectedVariantId = activeMetalBtn.dataset.variantId;
    }
  }

  // ── 4. THUMBNAILS ──
  document.querySelectorAll('.pdp-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      document.querySelectorAll('.pdp-thumb').forEach(function(t) {
        t.classList.remove('pdp-thumb--active');
      });
      thumb.classList.add('pdp-thumb--active');
      if (mainImg && thumb.dataset.src) {
        mainImg.src = thumb.dataset.src;
      }
    });
  });

  // ── 5. SHAPE SELECTOR (navegación por handle) ──
  var currentHandle = window.location.pathname.replace(/^\/products\//, '').split('?')[0];
  var shapes = ['round','oval','princess','cushion','pear','emerald','marquise','radiant'];

  // Detectar forma actual desde el handle (sufijo: -round, -oval, etc.)
  var currentShape = null;
  for (var i = 0; i < shapes.length; i++) {
    if (currentHandle.endsWith('-' + shapes[i])) {
      currentShape = shapes[i];
      break;
    }
  }

  // base handle sin el sufijo '-{forma}'
  var baseHandle = currentShape
    ? currentHandle.slice(0, -(currentShape.length + 1))
    : null;

  // Helper: diamond id desde URL param o sessionStorage
  function getDiamondParam() {
    var fromUrl = new URLSearchParams(window.location.search).get('diamond');
    if (fromUrl) return fromUrl;
    try {
      var d = JSON.parse(sessionStorage.getItem('diamore_diamond') || 'null');
      return (d && (d.id || d.diamond_id)) || '';
    } catch(e) { return ''; }
  }

  // Marcar shape activa y actualizar label
  var shapeValEl = document.getElementById('pdp-shape-val');
  document.querySelectorAll('.pdp-sbtn').forEach(function(btn) {
    var shape = (btn.dataset.shape || '').toLowerCase();
    if (shape === currentShape) {
      btn.classList.add('pdp-sbtn--active');
      if (shapeValEl) shapeValEl.textContent = btn.dataset.shapeLabel || '';
    } else {
      btn.classList.remove('pdp-sbtn--active');
    }
  });

  // Navegación por forma
  if (baseHandle) {
    var diamondParam = getDiamondParam();
    document.querySelectorAll('.pdp-sbtn').forEach(function(btn) {
      var shape = (btn.dataset.shape || '').toLowerCase();
      if (!shape || shape === currentShape) return;

      var siblingHandle = baseHandle + '-' + shape;
      var siblingUrl = '/products/' + siblingHandle +
        (diamondParam ? ('?diamond=' + encodeURIComponent(diamondParam)) : '');

      btn.addEventListener('click', function() {
        if (btn.classList.contains('pdp-sbtn--disabled') || btn.classList.contains('pdp-sbtn--shape-locked')) return;

        fetch('/products/' + siblingHandle, { method: 'HEAD' })
          .then(function(r) {
            if (r.ok) {
              window.location.href = siblingUrl;
            } else {
              btn.classList.add('pdp-sbtn--disabled');
              btn.disabled = true;
            }
          })
          .catch(function() {
            window.location.href = siblingUrl;
          });
      });
    });
  }

  // ── 6. CTA PRINCIPAL ──
  var ctaBtn = document.getElementById('pdp-cta-design');
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function(e) {
      e.preventDefault();

      var variantId = window._pdpSelectedVariantId
        || (document.querySelector('.pdp-mbtn--active') || {}).dataset.variantId
        || '';

      var titleEl = document.querySelector('.pdp-title');
      // Usar el variant encontrado para obtener el precio correcto (metal + stone type)
      var currentVariant = findSettingVariant(_activeMetalTitle, _activeStoneType);
      var settingPrice = currentVariant
        ? currentVariant.price
        : parseInt((document.querySelector('.pdp-mbtn--active') || {}).dataset.price || '0', 10);
      sessionStorage.setItem('diamore_setting', JSON.stringify({
        variantId: variantId,
        name:      titleEl ? titleEl.textContent.trim() : '',
        shape:     (window.DiamoreSettingPDP || {}).defaultShape || 'Round',
        price:     settingPrice,
        image:     mainImg ? mainImg.src : ''
      }));

      if (variantId) {
        sessionStorage.setItem('diamore_setting_variant', variantId);
      }

      var urlParams = new URLSearchParams(window.location.search);
      var diamondId = urlParams.get('diamond');

      // Flujo diamond-first: diamante ya está en sessionStorage
      if (!diamondId) {
        var flow = sessionStorage.getItem('diamore_flow');
        var hasDiamond = !!sessionStorage.getItem('diamore_diamond');
        if (flow === 'diamond-first' && hasDiamond) {
          try {
            var d = JSON.parse(sessionStorage.getItem('diamore_diamond') || 'null');
            diamondId = (d && (d.id || d.diamond_id)) || '';
          } catch(e) {}
        }
      }

      if (diamondId) {
        window.location.href = '/pages/ring-builder-review?setting=' + variantId + '&diamond=' + diamondId;
      } else {
        window.location.href = '/pages/ring-builder-diamond?setting=' + variantId;
      }
    });
  }

  // ── 7. STONE TYPE SELECTOR ──
  var stoneTypeBtns = document.querySelectorAll('#pdp-stone-type [data-stone]');

  var savedStoneType = sessionStorage.getItem('diamore_stone_type');
  if (savedStoneType === 'lab' || savedStoneType === 'natural') {
    stoneTypeBtns.forEach(function(btn) {
      btn.classList.remove('pdp-obtn--active');
      if (btn.dataset.stone === savedStoneType) {
        btn.classList.add('pdp-obtn--active');
      }
    });
  } else {
    sessionStorage.setItem('diamore_stone_type', 'lab');
  }

  function updateStoneTypeSpecs(stoneType) {
    document.querySelectorAll('.pdp-specs-val--lab').forEach(function(el) {
      el.style.display = stoneType === 'lab' ? '' : 'none';
    });
    document.querySelectorAll('.pdp-specs-val--natural').forEach(function(el) {
      el.style.display = stoneType === 'natural' ? '' : 'none';
    });
  }
  updateStoneTypeSpecs(_activeStoneType);

  stoneTypeBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      stoneTypeBtns.forEach(function(b) { b.classList.remove('pdp-obtn--active'); });
      btn.classList.add('pdp-obtn--active');
      _activeStoneType = btn.dataset.stone; // 'lab' | 'natural'
      sessionStorage.setItem('diamore_stone_type', _activeStoneType);
      updateStoneTypeSpecs(_activeStoneType);

      // Buscar variante por metal activo + nuevo stone type
      var variant = findSettingVariant(_activeMetalTitle, _activeStoneType);
      if (variant) {
        applyVariant(variant, null);
      }
    });
  });

  // ── 8. CONSULTA PRESENCIAL ──
  var consultBtn = document.getElementById('pdp-cta-consult');
  if (consultBtn) {
    consultBtn.addEventListener('click', function() {
      window.location.href = '/pages/reservar-cita';
    });
  }

  // ── 9. AUTO-SELECCIONAR FORMA DEL DIAMANTE ──
  // Solo aplica cuando venimos del flujo diamond-first y el producto
  // tiene variantes por forma (baseHandle detectado).
  (function() {
    if (!baseHandle) return; // no hay variantes de forma en este producto

    var rawDiamond = sessionStorage.getItem('diamore_diamond');
    var sessionDiamond = null;
    try { sessionDiamond = rawDiamond ? JSON.parse(rawDiamond) : null; } catch(e) {}

    if (!sessionDiamond) return; // sin diamante → no bloquear nada

    var diamondShape = (
      sessionDiamond.shape ||
      (sessionDiamond.certificate && sessionDiamond.certificate.shape) ||
      ''
    ).toLowerCase();

    // Bloquear botones de forma incompatibles con el diamante
    Array.from(document.querySelectorAll('[data-shape], .pdp-sbtn')).forEach(function(btn) {
      var btnShape = (btn.dataset.shape || '').toLowerCase();
      if (btnShape && btnShape !== diamondShape) {
        btn.style.opacity = '0.35';
        btn.style.pointerEvents = 'none';
        btn.classList.add('shape-incompatible');
        btn.classList.add('pdp-sbtn--shape-locked');
      }
    });

    if (!diamondShape || diamondShape === currentShape) return; // ya estamos en la forma correcta

    var shapeBtn = document.querySelector('[data-shape="' + diamondShape + '"]');
    if (shapeBtn && !shapeBtn.classList.contains('pdp-sbtn--disabled')) {
      shapeBtn.click();
    }
  })();

});
